import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons';
import Tooltip from 'components/Tooltip/Tooltip';

const useStyles = createUseStyles((theme: Theme) => ({
  dataItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.4rem',
    background: '#F9F9F9',
    borderRadius: 6,
    padding: '15px 20px',
    position: 'relative',
    width: '100%',
    '&:hover': {
      background: '#f5f4f4'
    }
  },
  dataItem__info: {
    display: 'flex',
    flexDirection: 'column',
    overflowWrap: 'anywhere'
  },
  dataItem__label: {
    color: theme.colors.textGrey,
    fontSize: '0.8rem',
    margin: 0
  },
  dataItem__value: {
    fontSize: '0.8rem',
    fontWeight: 500,
    margin: 0
  }
}));

type Props = {
  icon?: IconProp;
  iconColor?: string;
  iconFontSize?: string;
  style?: React.CSSProperties;
  label: string;
  children: any;
  helpText?: string;
  onClick?: () => void;
};

function DataItem(props: Props) {
  const classes = useStyles();

  return (
    <Tooltip
      text={props.helpText}
      style={props.style}
      onClick={props.onClick}
      className={classes.dataItem}
    >
      {props.icon && (
        <FontAwesomeIcon
          icon={props.icon}
          color={props.iconColor}
          style={
            {
              '--fa-primary-color': props.iconColor || '#ffcccc',
              '--fa-secondary-color': props.iconColor || '#ffcccc',
              fontSize: props.iconFontSize || '1.3rem'
            } as any
          }
        />
      )}
      <div className={classes.dataItem__info}>
        <p className={classes.dataItem__value}>{props.children}</p>
        <p className={classes.dataItem__label}>{props.label}</p>
      </div>
      <></>
    </Tooltip>
  );
}

export default DataItem;
